import { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { MDSTypography } from '@marqvision/mds-v2';
import { MDSHighlightedText } from '@marqvision/mds/core';

const useStyles = makeStyles(({ color }) => ({
  descriptionWrapper: {
    padding: '8px 12px',
    border: `1px solid ${color.border.neutral.default.normal}`,
    borderRadius: '4px',
    overflow: 'hidden',
    '&:hover': {
      overflow: 'auto',
    },
  },
}));

type Props = {
  minHeight?: string;
  maxHeight?: string;
  endIndex?: number | null;
  startIndex?: number | null;
  text: string;
  isDisabled?: boolean;
};

export const ScrollableDescription = (props: Props) => {
  const classes = useStyles();
  const { minHeight = '64px', maxHeight = '64px', isDisabled, text, startIndex, endIndex } = props;

  const descriptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const descriptionElement = descriptionRef.current;
    const highlightedTextElement = descriptionElement?.querySelector('span');

    if (descriptionElement && highlightedTextElement) {
      const parentElementPositionY = descriptionElement.getBoundingClientRect().top;
      const scrollPositionY = highlightedTextElement.getBoundingClientRect().top;
      const relativeTop = scrollPositionY - parentElementPositionY;

      if (highlightedTextElement) {
        descriptionElement.scrollTo({ top: relativeTop, behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div ref={descriptionRef} className={classes.descriptionWrapper} style={{ minHeight, maxHeight }}>
      <MDSTypography variant="T14" color={`color/content/neutral/default/${isDisabled ? 'disabled' : 'normal'}`}>
        <MDSHighlightedText text={text} startIndex={startIndex} endIndex={endIndex} />
      </MDSTypography>
    </div>
  );
};
